import { LocalDate } from '@js-joda/core';

import { PregnancyCompletionDateBasis } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { BindingCreator, FormContextValues } from '@dreryk/react-common';
import { Checkbox, StyledFlex } from '@dreryk/react-components';

import { gynecologicalInterviewTranslationKeys } from '../../../translations';

import { GynecologicalInterviewPredictedCompletionDateBasisSelect } from './GynecologicalInterviewPredictedCompletionDateBasisSelect';
import { GynecologicalInterviewPredictedCompletionDateDatePicker } from './GynecologicalInterviewPredictedCompletionDateDatePicker';

export type GynecologicalInterviewPatientPregnantFormBeanPart = {
   predictedCompletionDate: LocalDate | null;
   predictedCompletionDateBasis: PregnancyCompletionDateBasis | null;
   multiplePregnancy: boolean;
   pregnancyConfirmed: boolean;
};

export type GynecologicalInterviewPatientPregnantFormPartProps = {
   readonly register: BindingCreator<
      GynecologicalInterviewPatientPregnantFormBeanPart,
      keyof GynecologicalInterviewPatientPregnantFormBeanPart
   >;
   readonly watch: FormContextValues<GynecologicalInterviewPatientPregnantFormBeanPart>['watch'];
};

export const GynecologicalInterviewPatientPregnantFormPart = (
   props: GynecologicalInterviewPatientPregnantFormPartProps
): JSX.Element => {
   const selectedPredictedCompletionDate = props.watch('predictedCompletionDate');
   return (
      <>
         <StyledFlex direction={'column'} gap={'8px'}>
            <Checkbox
               testId={'pregnancyConfirmed'}
               controller={props.register('pregnancyConfirmed')}
               label={gynecologicalInterviewTranslationKeys.pregnancyConfirmed}
               // It's semantically important to have it explicit
               // eslint-disable-next-line react/jsx-boolean-value
               defaultValue={true}
            />
            <Checkbox
               testId={'multiplePregnancy'}
               controller={props.register('multiplePregnancy')}
               label={gynecologicalInterviewTranslationKeys.multiplePregnancy}
            />
         </StyledFlex>
         <StyledFlex gap={'24px'}>
            <GynecologicalInterviewPredictedCompletionDateDatePicker register={props.register} />
            {selectedPredictedCompletionDate === null ? null : (
               <GynecologicalInterviewPredictedCompletionDateBasisSelect register={props.register} />
            )}
         </StyledFlex>
      </>
   );
};
